import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=0f74fada&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=0f74fada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f74fada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f74fada')) {
      api.createRecord('0f74fada', component.options)
    } else {
      api.reload('0f74fada', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=0f74fada&scoped=true&", function () {
      api.rerender('0f74fada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eJJdLrnD9b5Y/JS/comp/Voucher.vue"
export default component.exports